import { rdRequests } from "../httpRequest";

const membershipApiRequests = {
  loadMembershipData: () => rdRequests.post(`WebAccessMembership/Load/MembershipDetails`, {}),
  getSelectedMembershipDetails: (membershipParameters: any) => rdRequests.post(`WebAccessMembership/SelectedMembershipDetails`, membershipParameters),
  validateMembershipCartDetails: (membershipParameters: any) => rdRequests.post(`WebAccessMembership/ValidateMembershipCartDetails`, membershipParameters),
  validateMembershipMultiUserRestrictions: (multiMembershipParameters: any) => rdRequests.post(`WebAccessMembership/ValidateMembershipMultiUserRestrictions`, multiMembershipParameters)
}

export default membershipApiRequests;